export default __webpack_public_path__ + "static/media/hero-leanMedium.fcc70648.jpg";